import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useMetaStore } from '../store/MetaStore'
import { useRoundStore } from '../store/RoundStore'

const HoleButton = ({ holeAdvance, isDisabled }) => {
  const holeNum = useRoundStore((state) => state.holeNum)
  const setHoleNum = useRoundStore((state) => state.setHoleNum)
  const roundHoleCount = useRoundStore((state) => state.roundHoleCount)
  const saveData = useRoundStore((state) => state.saveData)
  const logout = useMetaStore((state) => state.logout)

  const navigate = useNavigate()

  let label = `#${holeNum + holeAdvance}`
  if (holeNum > roundHoleCount - 1 && holeAdvance > 0) {
    label = 'DONE'
  } else if (holeAdvance > 0) {
    label = label + ' ►'
  } else {
    label = '◄ ' + label
  }

  let click = async () => {
    let response = await saveData()

    if (response.error) {
      logout()
      useMetaStore.getState().setErrorMsg(response.error)
      navigate('/error')
    } else {
      if (holeNum === roundHoleCount && holeAdvance > 0) {
        navigate('/leaderboard')
      } else {
        setHoleNum(holeNum + holeAdvance)
      }
    }
  }

  if (holeNum === 1 && holeAdvance < 0) {
    return <></>
  }

  return (
    <button type="button" className="darkButton" style={{ width: '100px', height: '45px' }} onClick={click} disabled={isDisabled}>
      {label}
    </button>
  )
}

export default HoleButton
